import { Component, OnDestroy } from '@angular/core';
import { Subject } from 'rxjs';

@Component({
    selector: 'nha-base-service',
    template: '',
    standalone: false
})
export abstract class BaseService implements OnDestroy {
	protected serviceDestroyed$: Subject<boolean> = new Subject();

	ngOnDestroy(): void {
		this.serviceDestroyed$.next(true);
		this.serviceDestroyed$.complete();
	}
}
